import { Icon } from "@grassrootly/rn-core";
import { MainStackScreenProps } from "../../navigation/Navigation.types";
import { ScreenLayout } from "../../layout/components";
import { useJoinGroup } from "./useJoinGroup";
import { JoinGroupForm } from "./JoinGroupForm";
import { joinForm } from "./JoinGroup.types";

export default function JoinGroupScreen({ navigation, route }: MainStackScreenProps<"join-group">) {
  const { onSubmitJoinGroup } = useJoinGroup({ navigation });

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }
    navigation.navigate("my-groups");
  };

  return (
    <ScreenLayout
      header={{
        center: `JOIN GROUP`,
        left: <Icon name="arrow_back_ios" size={24} onPress={goBack} classNames={["mb-{5}"]} />,
      }}
    >
      <JoinGroupForm onSubmit={onSubmitJoinGroup} joinGroupForm={joinForm} />
    </ScreenLayout>
  );
}
